import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export function AuthCallback() {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Signal that authentication callback is in progress
        sessionStorage.setItem('authCallbackInProgress', 'true');
        
        // Get the return path with highest priority to sessionStorage
        let returnTo = sessionStorage.getItem('preLoginReturnPath');
        
        if (!returnTo) {
          // Get return path from localStorage
          const pathDataString = localStorage.getItem('authReturnPathData');
          
          if (pathDataString) {
            try {
              const pathData = JSON.parse(pathDataString);
              returnTo = pathData.returnPath;
            } catch (e) {
              console.error('AuthCallback: Error parsing return path data:', e);
            }
          }
          
          // Fallback to legacy path if needed
          if (!returnTo) {
            returnTo = localStorage.getItem('authReturnPath');
          }
        }
        
        // Default to home if no return path found
        if (!returnTo) {
          returnTo = '/';
        }
        
        // Check for pending save action
        const pendingSaveIdeaId = sessionStorage.getItem('pendingSaveIdeaId');
        if (pendingSaveIdeaId && returnTo.includes('/ideas/')) {
          // Potentially log this if it's a critical part of the flow, or handle it.
          // For now, assuming it's informational for debugging.
        }
        
        // Ensure we have a valid session
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('AuthCallback: Session error:', error);
          navigate('/login', { replace: true });
          return;
        }

        if (data.session) {
          // Clear localStorage return paths only after we've obtained the path
          localStorage.removeItem('authReturnPath');
          localStorage.removeItem('authReturnPathData');
          
          // Wait a moment before redirecting to ensure Supabase has fully processed the session
          setTimeout(() => {
            // Use navigate for a clean redirect user
            navigate(returnTo, { replace: true });
            
            // Remove the processing flag after redirect is initiated
            setTimeout(() => {
              sessionStorage.removeItem('authCallbackInProgress');
              sessionStorage.removeItem('preLoginReturnPath');
            }, 1000);
          }, 500);
        } else {
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('AuthCallback: Error handling callback:', error);
        sessionStorage.removeItem('authCallbackInProgress');
        navigate('/login', { replace: true });
      } finally {
        setIsProcessing(false);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Completing Sign In</h2>
        <p className="text-gray-600">{isProcessing ? 'Please wait...' : 'Redirecting...'}</p>
      </div>
    </div>
  );
}